import { useI18n } from "../../lib/useI18n.js";

/** Shared Any/All segmented toggle used by the topic + label sidebar filters. */
export function ModeToggle({ mode, setMode, noun }: { mode: "any" | "all"; setMode: (m: "any" | "all") => void; noun: string }) {
  const { t } = useI18n();
  return (
    <div className="flex overflow-hidden rounded-md border text-xs">
      {(["any", "all"] as const).map((m) => (
        <button
          key={m}
          type="button"
          onClick={() => setMode(m)}
          className={`px-2 py-0.5 capitalize ${mode === m ? "bg-accent text-foreground" : "text-muted-foreground hover:bg-accent/50"}`}
          title={t(m === "any" ? "sidebar.matchAny" : "sidebar.matchAll", { noun })}
        >
          {t(m === "any" ? "sidebar.any" : "sidebar.all")}
        </button>
      ))}
    </div>
  );
}
